// Texts of the ERP area "Automações comerciais" (regras, matriz de frequência, feriados e registro do motor).
export default {
  automation: {
    title: 'Automações comerciais',
    subtitle: 'O que o CRM agenda sozinho, em quanto tempo e para quem.',
    readOnly: 'Somente leitura: alterar regras, matriz e feriados exige a permissão “Administrar automações”.',
    tabs: { rules: 'Regras', templates: 'Modelos de e-mail', matrix: 'Matriz de frequência', holidays: 'Feriados', executions: 'Registro' },
    templates: {
      new: 'Novo modelo',
      edit: 'Editar modelo',
      hint: 'Os textos usados em "Enviar e-mail" nas atividades. O vendedor sempre revisa antes de enviar; campos sem valor bloqueiam o envio.',
      empty: 'Nenhum modelo de e-mail',
      name: 'Nome',
      purposeLabel: 'Finalidade',
      purpose: {
        first_contact: 'Primeiro contato',
        presentation: 'Apresentação',
        invitation: 'Convite',
        proposal: 'Proposta',
        feedback: 'Pedido de retorno',
        follow_up: 'Retomada',
        satisfaction: 'Satisfação',
        other: 'Outro',
      },
      subject: 'Assunto',
      body: 'Texto',
      cc: 'Sempre em cópia (Cc)',
      bcc: 'Sempre em cópia oculta (Cco)',
      copyHint: 'Entra em todo e-mail deste modelo; dá para mudar antes de enviar.',
      insert: 'Inserir campo:',
      unknown: 'Campos que o sistema não conhece (confira a grafia): {list}',
      attachment: 'Anexo',
      fileDrop: 'Arraste o arquivo ou clique para escolher',
      replaceFile: 'Trocar o anexo',
      fileHint: 'Um arquivo de até 8 MB (ex.: a apresentação em PDF).',
      pendingFile: '{name} será anexado ao salvar.',
      defaultFor: 'Modelo padrão destes tipos de atividade',
      defaultForShort: 'Padrão de',
      active: 'Modelo ativo',
      activeLabel: 'Ativo',
      inactiveLabel: 'Inativo',
      preview: 'Prévia (com valores de exemplo)',
      updated: 'Alterado em',
      deleteText: 'O modelo será excluído. Os e-mails já enviados continuam no histórico.',
      deleteCatalog: 'É um modelo do catálogo padrão: excluído, ele não volta. Os e-mails já enviados continuam no histórico.',
    },
    coverage: {
      uncovered: 'Empresas sem próxima atividade',
      detail: '{none} sem atividade · {late} só com atrasadas · {owner} sem responsável',
      covered: 'Empresas ativas com próxima atividade',
      excluded: '{n} sem exigência de próxima atividade',
      lastRun: 'Última verificação',
      lastRunText: '{created} criadas, {left} descobertas depois',
      never: 'Ainda não verificado',
      failed: 'A última verificação falhou: {error}',
      run: 'Verificar agora',
      ran: 'Verificação concluída: {created} atividades criadas, {left} empresas descobertas',
    },
    sentence: 'Quando {when}, então “{title}” {delay}',
    delayIn: 'em {delay}',
    delay: {
      now: 'imediatamente',
      matrix: 'pelo prazo da matriz',
      hours: '{n} hora | {n} horas',
      days: '{n} dia | {n} dias',
      business_days: '{n} dia útil | {n} dias úteis',
    },
    unit: { hours: 'Horas', days: 'Dias corridos', business_days: 'Dias úteis', matrix: 'Prazo da matriz de frequência' },
    recurrence: {
      once: 'Uma vez por evento',
      after_completion: 'De novo a cada conclusão',
      every_contact: 'A cada contato (acompanhamento periódico)',
    },
    recurrenceShort: { after_completion: '(repete a cada conclusão)', every_contact: '(renova a cada contato)' },
    priority: { high: 'Alta', medium: 'Média', low: 'Baixa' },
    dedup: {
      same_rule_open: 'Não criar se já houver uma aberta desta regra',
      same_type_open: 'Não criar se já houver uma aberta do mesmo tipo',
      none: 'Sempre criar',
    },
    trigger: {
      any_contact: 'qualquer contato',
      customer_created: 'empresa cadastrada',
      stage_changed: 'fase alterada',
      owner_changed: 'responsável alterado',
      relationship_changed: 'relacionamento alterado',
      potential_changed: 'potencial alterado',
      contact_registered: 'contato registrado',
      meeting_held: 'reunião realizada',
      proposal_created: 'proposta criada',
      proposal_sent: 'proposta enviada',
      proposal_approved: 'proposta aprovada',
      proposal_rejected: 'proposta recusada',
      proposal_expired: 'proposta vencida',
      proposal_cancelled: 'proposta cancelada',
      activity_completed: 'atividade concluída',
      activity_cancelled: 'atividade cancelada',
      activity_deleted: 'atividade excluída',
      email_sent: 'e-mail enviado',
      coverage_missing: 'empresa sem próxima atividade',
      rule_changed: 'regra alterada',
    },
    result: {
      created: 'Criada',
      rescheduled: 'Remarcada',
      duplicate: 'Já existia',
      cancelled: 'Cancelada',
      reassigned: 'Transferida',
      failed: 'Falhou',
    },
    rules: {
      new: 'Nova regra',
      search: 'Nome, atividade ou gatilho',
      active: 'Ligada',
      inactive: 'Desligada',
      turnOn: 'Ligar',
      turnOff: 'Desligar',
      turnedOn: 'Regra ligada: vale para o que acontecer daqui em diante.',
      turnedOff: 'Regra desligada. As atividades já criadas continuam.',
      duplicate: 'Duplicar',
      deleteText: 'A regra deixa de agir. As atividades já criadas por ela continuam na agenda.',
      deleteCatalog: 'É uma regra do catálogo inicial: excluída, ela não volta. As atividades já criadas continuam na agenda.',
      columns: {
        name: 'Regra',
        activity: 'Atividade',
        delay: 'Prazo',
        open: 'Abertas',
        lastRun: 'Última execução',
        status: 'Situação',
      },
    },
    editor: {
      new: 'Nova regra',
      edit: 'Editar regra',
      version: 'Versão {n}',
      name: 'Nome da regra',
      when: 'Quando',
      trigger: 'Evento',
      triggerType: 'Tipo da atividade',
      anyType: 'Qualquer tipo',
      if: 'Se',
      stages: 'Fase',
      relationships: 'Relacionamento',
      potentials: 'Potencial',
      all: 'Todos',
      openProposal: 'Proposta em aberto',
      proposalAny: 'Tanto faz',
      proposalYes: 'Só com proposta em aberto',
      proposalNo: 'Só sem proposta em aberto',
      then: 'Então',
      activityType: 'Tipo da atividade',
      chooseType: 'Escolha o tipo',
      title: 'Título da atividade',
      priority: 'Prioridade',
      assignee: 'Responsável',
      accountOwner: 'Responsável pela empresa',
      in: 'Em',
      amount: 'Prazo',
      unit: 'Unidade',
      fallback: 'Prazo se a matriz não tiver o caso (dias)',
      fallbackHint: 'A matriz de frequência decide; este número só vale quando ela não cobre a combinação.',
      repeat: 'Repetir',
      recurrence: 'Recorrência',
      dedup: 'Se já houver atividade equivalente',
      stop: 'Parar quando',
      stopHint: 'As atividades abertas desta regra são canceladas quando um destes eventos acontece. Atividades manuais nunca são tocadas.',
      rulePriority: 'Prioridade da regra (0 a 100)',
      rulePriorityHint: 'Quando duas regras criariam a mesma atividade, vale a de número maior.',
      active: 'Regra ligada',
      description: 'Descrição (opcional)',
      preview: 'Nenhuma empresa atende hoje | 1 empresa atende hoje | {n} empresas atendem hoje',
      nextDate: 'Se o evento acontecesse agora, a atividade seria para {date}',
      savedRecalculated: 'Regra salva. 1 atividade foi remarcada. | Regra salva. {n} atividades foram remarcadas.',
    },
    policy: {
      title: 'O prazo mudou',
      text: 'O que fazer com as atividades já agendadas? Concluídas e manuais nunca mudam. | Há 1 atividade aberta desta regra. O que fazer com ela? Concluídas e manuais nunca mudam. | Há {n} atividades abertas desta regra. O que fazer com elas? Concluídas e manuais nunca mudam.',
      new_only: 'Só nas próximas',
      new_onlyHint: 'As já agendadas ficam como estão; o prazo novo vale para as que forem criadas daqui em diante.',
      recalculate_future: 'Recalcular as futuras',
      recalculate_futureHint: 'As automáticas ainda não iniciadas são remarcadas pelo prazo novo.',
      from_date: 'A partir de uma data',
      from_dateHint: 'O prazo novo vale para os eventos a partir da data escolhida.',
      from: 'Vale a partir de',
    },
    matrix: {
      hint: 'Dias até o próximo contato, por fase e relacionamento. Usada pelo acompanhamento periódico e pela garantia de próxima atividade. Deixe em branco para não ter acompanhamento automático na combinação.',
      stage: 'Fase',
      unrated: 'Sem avaliação',
      days: 'dias',
      daysLabel: 'Dias',
      exceptions: 'Exceções por potencial',
      exceptionsHint: 'Quando a empresa tem este potencial, o prazo da exceção substitui o da tabela.',
      addException: 'Adicionar exceção',
      updated: 'Alterada por {name} em {date}',
    },
    holidays: {
      year: 'Ano',
      new: 'Novo feriado',
      edit: 'Editar feriado',
      date: 'Data',
      name: 'Nome',
      source: 'Origem',
      national: 'Nacional',
      institution: 'Da empresa',
      yearly: 'todo ano',
      recurring: 'Repete todo ano',
      worked: 'Trabalhamos',
      work: 'Trabalhamos neste dia',
      countAgain: 'Voltar a considerar feriado',
    },
    exclusion: {
      exclude: 'Não exigir próxima atividade',
      include: 'Voltar a exigir próxima atividade',
      badge: 'Próxima atividade não exigida para esta empresa',
      excludeTitle: 'Não exigir próxima atividade de “{name}”?',
      excludeText: 'O sistema deixa de criar o “Próximo contato obrigatório” para esta empresa. As atividades já agendadas continuam.',
      includeTitle: 'Voltar a exigir próxima atividade de “{name}”?',
      includeText: 'Na próxima verificação, se a empresa estiver sem próxima atividade, o sistema agenda o contato obrigatório.',
      reason: 'Motivo (fica registrado)',
      excluded: 'A próxima atividade não é mais exigida para esta empresa.',
      included: 'A próxima atividade volta a ser exigida para esta empresa.',
    },
    executions: {
      when: 'Quando',
      company: 'Empresa',
      rule: 'Regra',
      result: 'Resultado',
      message: 'Detalhe',
      empty: 'Nenhuma execução registrada',
      failedTitle: '1 evento não processado | {n} eventos não processados',
      attempts: '{n} tentativas',
      retry: 'Tentar de novo',
      retried: 'Evento colocado na fila de novo.',
    },
  },
}
